import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-chevron-down.tsx
/**
* icon.16.chevron.down
*
* Keywords: caret, downward, pointing, angle, navigation, expand, below
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuNzY4IDYuNzY4YS41LjUgMCAwIDEgLjcwNy43MDdsLTIuMTIgMi4xMjFhLjUuNSAwIDAgMS0uNzA4IDBMNS41MjUgNy40NzVhLjUuNSAwIDAgMSAuNzA4LS43MDdsMS43NjggMS43Njd6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11752
*/
const Icon16ChevronDown = memo(function Icon16ChevronDown(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M9.768 6.768a.5.5 0 0 1 .707.707l-2.12 2.121a.5.5 0 0 1-.708 0L5.525 7.475a.5.5 0 0 1 .708-.707l1.768 1.767z"
		})
	});
});
//#endregion
export { Icon16ChevronDown };

//# sourceMappingURL=icon-16-chevron-down.js.map